import React, { Component, useState } from "react";
import { Button, message, Steps, Select, Checkbox, Row, Col, Form, Table, Tabs, Dropdown, Skeleton, Space, Modal } from 'antd';
import "./CallReports.css";
import styles from './CallReports.module.css';
import CallReportPreview from "./CallReportPreview";
import * as com from "../../Common"
import { initial, cloneDeep } from "lodash";
import {decode, Base64} from 'js-base64';
import { UR_LoanOfficer, UR_Owner,  } from "../../State";
import moment from 'moment';
import { MCR_ENDPOINT_V0, QUARTER_START_DATE, QUARTER_END_DATE } from "./constants";
import { track } from "statsig";
import { STATSIG, PAGE } from "statsig/events";

class CallReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedYear: new Date().getFullYear().toString(),
            selectedQuarter: this.getQuarter(),
            selectedStates: [],
            statesOptions: [],
            currentstep: 0,
            callreportdata: undefined,
            callreportdatatoSave: undefined,
            openingGeneratedReport: false,
            loanofficers: {},
            reportSaved: false,
            showConfirmBackModal: false,
            newChange: false,
            reportDataByState: null,
            currentPage: 1,
        };
    }

    componentDidMount() {
        track(STATSIG.COMMON.VIEW, PAGE.CALL_REPORTS, { page: PAGE.CALL_REPORTS });
        this.getCompanyStates();
    }


    componentDidUpdate(prevProps, prevState) {
        if (prevState.callreportdata !== this.state.callreportdata) {
        }
      }

    getLoanofficers = () => {
        let token = sessionStorage.getItem("ZeitroA")
        this.setState({loading: true})
        fetch('/los/loanofficerlist', {
          method: 'GET',
          headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache"
          }
        }).then(
          response => {
            if (response.status !== 200) {
              console.log('Looks like there was a problem. Status Code: ' +
                response.status);
              this.setState({ loading: false })
              return;
            }
            // Examine the text in the response
            response.json().then(js => {
    
              if (js.Status !== "OK") {
                console.log("Error: " + js.Text)
                this.setState({ loading: false })
              } else {
    
                let docs = js.LoanOfficers.filter(el => el.Roles.includes(UR_LoanOfficer));
                docs = docs.map(s => {
                  let lo = cloneDeep(this.state.loanofficers)
                  lo[s.ID] = s.FirstName + " " + s.LastName + "_" + s.Nmls
                  this.setState({ loanofficers: lo })
    
                  return {
                    rand: Math.random(), id: s.ID, email: s.Email, nmlsid: s.Nmls,
                    firstname: s.FirstName, lastname: s.LastName, phone: s.Phone, image: s.Image === "" ? "/avatar.png" : s.Image
                  }
                })
                this.setState({ loanofficers_full: docs })
              }
              let loans = this.state.Loans.map(s => {
                let lo = "Unassigned"
                if (this.state.loanofficers[s.lo_id])
                  lo = this.state.loanofficers[s.lo_id]
    
                return { ...s, loanofficer: lo }
              }
    
    
              )
              
              this.setState({ Loans: loans})
              this.getAllReports();
            });
          }
        )
          .catch(function (err) {
            console.log('Fetch Error :-S', err);
            this.setState({ loading: false })
    
          });
      }
    
    getAllReports = () => {
        let token=sessionStorage.getItem("ZeitroA")
        fetch('/los/getallcallreport', {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
            }).then(
            response => {
                if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' +
                    response.status);
                this.setState({loading: false})
                return;
                }
                response.json().then(js => {
                if (js.Status !== "OK") {
                    console.log("Error: " + js.Text)
                    this.setState({loading: false})
                } else {
                    if (js.Records) {
                        let records = js.Records.map(s => {
                            return {
                                name: s.Name,
                                quarter: s.Quarter,
                                year: s.Year,
                                state: s.State,
                                generateddate: s.GeneratedDate,
                                data: JSON.parse(decode(s.Data)),
                                pipeline: JSON.parse(decode(s.Pipeline)),
                            }
                        })
                        this.setState({Records: records})
                    }
                    this.setState({loading: false})
                }
                });
            }
            )
            .catch(function (err) {
                console.log('Fetch Error :-S', err);
                this.setState({loading: false})
            });
    }

    getCompanyStates = () => {
        this.setState({loading: true})
        let token = sessionStorage.getItem("ZeitroA")
        fetch(MCR_ENDPOINT_V0 + 'getCompanyStates', {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        })
        .then(response => {
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' + response.status);
                this.setState({loading: false})
                return;
            }
            response.json().then(js => {
                if (!js.data) {
                    this.setState({loading: false})
                    return;
                }
                let data = js.data.filter(s => s !== "")
                let states = data.map(s => s.toLowerCase())
                let statesOptions = data.map(s => {
                    return {
                        label: com.convertAbbStateToFull(s),
                        value: s.toLowerCase(),
                        abbr: s
                    }
                })
                // render statesOptions and auto select all options
                this.setState({
                    statesOptions: statesOptions,
                    selectedStates: states,
                
                }, () =>{
                    this.getloans();
                })
            })
        })
        .catch(function (err) {
            console.log('Fetch Error :-S', err);
            this.setState({loading: false})
        });
    }

    getloans = () => {
        this.setState({loading: true})
        let token = sessionStorage.getItem("ZeitroA")
        fetch('/los/loansforcallreport', {
        method: 'GET',
        headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache"
        }
        }).then(
        response => {
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' +
                response.status);
                this.setState({loading: false})
            return;
            }
            response.json().then(js => {

            if (js.Status !== "OK") {
                console.log("Error: " + js.Text)
                this.setState({loading: false})
            } else {
                if (js.Loans) {
                    let docs = js.Loans.map(s => {
                        return {
                        firstname: s.FirstName,
                        lastname: s.LastName,
                        loanid: s.LoanID,
                        status: s.Status,
                        purpose:s.LoanPurpose,
                        price:s.LoanPrice,
                        started: s.Started,  
                        loanamount:s.LoanSize,
                        lo_id: s.LoanOfficerID,
                        address: s.PropertyAddressStreet,
                        county: s.PropertyAddressCounty,
                        state: s.PropertyAddressState,
                        mtype: s.TypeOfMortgage,
                        mortgageapplied: s.MortgageApplied,
                        amortization: s.Amortization,
                        loanterm: s.Term,
                        apr: s.APR,
                        baserate: s.BaseRate,
                        monthlypay: s.MonthlyPay,
                        lenderfee: s.LenderFee,
                        propertytype: s.PropertyType,
                        occupancy: s.Occupancy,
                        hascontract: s.HasContract,
                        unknownpurpose: s.UnknownPurpose,
                        }
                    })
                    this.setState({Loans: docs}, () => {
                        this.getLoanofficers();
                    })
                } else {
                    this.setState({ loading: false })
                }
            }
            });
        }
        )
        .catch(function (err) {
            console.log('Fetch Error :-S', err);
            this.setState({loading: false})
        });
    }

    getYears = () => {
        let currentYear = new Date().getFullYear();
        let nextYear = currentYear + 1;
        let years = Array.from({length: 3}, (_, i) => nextYear - i);
        let yearsOptions = years.map((year) => {
            let yearString = year.toString();
            return <option value={yearString}>{yearString}</option>
        })
        return yearsOptions;
    }

    getQuarter = () => {
        let month = new Date().getMonth();
        switch (true) {
            case month < 3:
                return 'q1';
            case month < 6:
                return 'q2';
            case month < 9:
                return 'q3';
            default:
                return 'q4';
        }
    }

    viewGeneratedReport = (record) => {
        track(STATSIG.CALL_REPORTS.REPORT_OPEN);
        this.setState({
            openingGeneratedReport: true,
            callreportdata: this.state.Records.find((r) => r.name === record.name),
            currentstep: 1, 
        })
        this.props.setManagementMenuHidden(true)
    }

    handleSaveAndExit = () => {
        this.handleSaveReport();
        this.handelGoBack();
        message.success({
            content: "Report saved successfully",
            className: styles.successMessage,
        })
    }

    handelGoBack = () => {
        this.setState({currentstep: 0, reportSaved: false, callreportdata: null})
        if(this.state.openingGeneratedReport) {
            this.setState({openingGeneratedReport: false})
        }
        this.props.setManagementMenuHidden(false)
    }

    renderConfirmBackModal = () => {
        return <Modal
            title={"Save your report?"}
            open={this.state.showConfirmBackModal}
            onCancel={() => this.setState({showConfirmBackModal: false})}
            rootClassName="confirmBackModal"
            footer={
                <div className="confirmModalFooter">
                    <Button 
                        className="noSaveButton"
                        onClick={() => {
                            this.setState({showConfirmBackModal: false})
                            this.handelGoBack(); 
                        }}
                    >
                        Exit without saving
                    </Button>
                    <Button 
                        className="saveAndGoButton"
                        type="primary"
                        onClick={() => {
                            this.handleSaveReport(); 
                            this.setState({showConfirmBackModal: false})
                            this.handelGoBack();
                        }}
                    >
                        Save report
                    </Button>
                </div>
            }
            >
                <div className="contentBodyWrap">
                    {/* <div className="BodyTitle">Save your report?</div> */}
                    <div className="BodyText">Would you like to save this report before leaving this page?</div>
                </div>
            </Modal>
    }

    handleUpdateReport = () => {
        let body = {
            name: this.state.callreportdatatoSave.name,
            state: this.state.callreportdatatoSave.state,
            quarter: this.state.callreportdatatoSave.quarter,
            year: this.state.callreportdatatoSave.year,
            generateddate: this.state.callreportdatatoSave.generateddate,
            data: com.ascii2hex(JSON.stringify(this.state.callreportdatatoSave.data))
        }
        let token = sessionStorage.getItem("ZeitroA")
        fetch('/los/updatecallreport', {
            method: 'POST',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            },
            body: JSON.stringify(body)
        })
        .then(response => {
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' + response.status);
                return;
            }
            response.json().then(js => {
                if (js.Status !== "OK") {
                    console.log("Error: " + js.Text)
                }
                else {
                    this.getAllReports();
                    this.setState({reportSaved: true})
                }
            })
        })
    }

    handleSaveReport = () => {
        let body = {
            name: this.state.callreportdata.name,
            state: this.state.callreportdata.state,
            quarter: this.state.callreportdata.quarter,
            year: this.state.callreportdata.year,
            generateddate: this.state.callreportdata.generateddate,
            data: com.ascii2hex(JSON.stringify(this.state.callreportdata.data)),
            pipeline: com.ascii2hex(JSON.stringify(this.state.callreportdata.pipeline))
        }
        let token = sessionStorage.getItem("ZeitroA")
        fetch('/los/savecallreport', {
        method: 'POST',
        headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache"
        },
        body: JSON.stringify(body)
        })
        .then(
        response => {
            if (response.status !== 200) {
            console.log('Looks like there was a problem. Status Code: ' +
                response.status);
            return;
            }
            response.json().then(js => {

            if (js.Status !== "OK") {
                console.log("Error: " + js.Text)
            } else {
                // alert("Report Saved Successfully")
                // this.setState({currentstep: 0}, () => {
                //     this.getAllReports();
                // })
                // if(this.state.openingGeneratedReport) {
                //     this.setState({openingGeneratedReport: false})
                // }
                this.getAllReports();
                this.setState({reportSaved: true})
                if (!this.state.openingGeneratedReport) {
                    track(STATSIG.CALL_REPORTS.INSERT)
                }
            }
            });
        }
        )
        .catch(function (err) {
            console.log('Fetch Error :-S', err);
        });
    }

    clearStateFormat = (states) => {
        let result = states.map((state) => {
            return state.replace("{", "").replace("}", "")
        })
        return result;
    }

    exportHistoryReport = (record) => {
        this.setState({
            callreportdata: this.state.Records.find((r) => r.name === record.name),
        }, () => {
            this.exportCallReport("excel", "history")
        })
    }

    deleteHistoryReport = (record) => {
        let token = sessionStorage.getItem("ZeitroA")
        fetch(MCR_ENDPOINT_V0 + 'deleteCallReport', {
            method: 'POST',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            },
            body: JSON.stringify({name: record.name})
        })
        .then(response => {
            if (response.status !== 200) {
                console.log('Error: Status Code ' + response.status);
                return;
            }
            response.json().then(js => {
               this.setState({Records: this.state.Records.filter((r) => r.name !== record.name)})
               track(STATSIG.CALL_REPORTS.DELETE)
               message.success({
                content: "Report deleted successfully",
                className: styles.successMessage,
               })
            })
        })
        .catch(err => {
            console.log('Fetch Error :-S', err);
        });
    }

    exportCallReport = (type, source) => {
        let body = {
            type: type,
            data: com.ascii2hex(JSON.stringify(this.state.callreportdata.data)),
            name: this.state.callreportdata.name,
            state: this.state.openingGeneratedReport ? this.clearStateFormat(this.state.callreportdata.state) : this.state.callreportdata.state,
            quarter: this.state.callreportdata.quarter,
            year: this.state.callreportdata.year,
            pipeline: com.ascii2hex(JSON.stringify(this.state.callreportdata.pipeline))
        };
        let token = sessionStorage.getItem("ZeitroA");
    
        fetch('/los/exportcallreport', {
            method: 'POST',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            },
            body: JSON.stringify(body)
        })
        .then(response => {
            if (response.status !== 200) {
                console.log('Error: Status Code ' + response.status);
                return;
            }
            return response.blob();
        })
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            if (type === "xml") {
                a.download = `${this.state.callreportdata.name}.xml`;
            } else {
                a.download = `${this.state.callreportdata.name}.xlsx`;
            }
            document.body.appendChild(a);
            a.click();
            a.remove();
            const exportSource = source || 'review'
            track(STATSIG.CALL_REPORTS.EXPORT, exportSource, { source: exportSource })
            window.URL.revokeObjectURL(url);
        })
        .catch(err => {
            console.log('Fetch Error :-S', err);
        });
    }

    createReport = (values) => {
        let initialdata = {
            // companyid: sessionStorage.getItem("ZeitroA"),
            name: "MCR_"+values.quarter.toUpperCase()+"_"+values.year,
            generateddate: new Date().toLocaleDateString('en-US'),
            state: values.states,
            quarter: values.quarter,
            year: values.year,
            data:{
                ca: {},
                tx: {}
            }
        }
        values.states.forEach((state) => {
            initialdata.data[state] = cloneDeep(com.callReportInitValues)
        })
        this.setState({callreportdata: cloneDeep(initialdata), callreportdatatoSave: cloneDeep(initialdata), currentstep: 1, reportSaved: false, newChange: false})
    }

    generateNewReportData = (values) => {

        if(!values.states || values.states.length === 0) {
            message.error("Please select at least one state")
            return
        }

        this.setState({loading: true, callreportdata: null})
        let token = sessionStorage.getItem("ZeitroA")
        let body = {
            year: parseInt(values.year), 
            quarterStartDate: QUARTER_START_DATE[values.quarter],
            quarterEndDate: QUARTER_END_DATE[values.quarter],
            customerId: com.getCustomerId(),
            states: values.states.map(s => s.toUpperCase())
        }
        fetch(MCR_ENDPOINT_V0 + 'generateNewReportData', {
            method: 'POST',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            },
            body: JSON.stringify(body)
        })
        .then(response => {
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' + response.status);
                alert("Looks like there was a problem. Status Code: " + response.status);
                this.setState({loading: false})
                return;
            }
            response.json().then(js => {
                let reportData = {}
                js.data.forEach(s => {
                    reportData[s.state_code.toLowerCase()] = s.call_report_data
                })
                let entirePipeline = []
                js.data.forEach(s => {
                    entirePipeline.push(...s.pipeline_data)
                })
                let dataToSave = {
                    data: reportData,
                    pipeline: entirePipeline,
                    state: values.states,
                    quarter: values.quarter,
                    year: values.year,
                    generateddate: new Date().toLocaleDateString('en-US'),
                    name: "MCR_"+values.quarter.toUpperCase()+"_"+values.year,
                }
                this.setState({callreportdata: dataToSave, reportSaved: false, loading: false, currentstep: 1})
                this.props.setManagementMenuHidden(true)
                track(STATSIG.CALL_REPORTS.GENERATE)
            })
        })
        .catch(function (err) {
            console.log('Fetch Error :-S', err);
            this.setState({loading: false})
        });
    }

    updateCurrentStep = (step) => {
        this.setState({currentstep: step});
    }

    getPaginatedData = () => {
        const { Records, currentPage } = this.state;
        const pageSize = 3;
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return Records ? Records.slice(startIndex, endIndex) : [];
    }

    render() {

        const CustomPagination = ({ current, total, pageSize, onChange }) => {
            const totalPages = Math.ceil(total / pageSize);
            
            const getPageNumbers = () => {
                const pages = [];
                const maxVisiblePages = 5;
                
                if (totalPages <= maxVisiblePages) {
                    // Show all pages if total is small
                    for (let i = 1; i <= totalPages; i++) {
                        pages.push(i);
                    }
                } else {
                    // Always show first page
                    pages.push(1);
                    
                    if (current <= 3) {
                        // Show pages 1, 2, 3, ..., last
                        pages.push(2, 3);
                        if (totalPages > 4) {
                            pages.push('...');
                        }
                        pages.push(totalPages);
                    } else if (current >= totalPages - 2) {
                        // Show first, ..., last-2, last-1, last
                        if (totalPages > 4) {
                            pages.push('...');
                        }
                        pages.push(totalPages - 2, totalPages - 1, totalPages);
                    } else {
                        // Show first, ..., current-1, current, current+1, ..., last
                        pages.push('...');
                        pages.push(current - 1, current, current + 1);
                        pages.push('...');
                        pages.push(totalPages);
                    }
                }
                
                return pages;
            };
                    return (
            <div className={styles.customPagination}>
                <button 
                    className={`${styles.paginationBtn} ${current === 1 ? styles.disabled : ''}`}
                    onClick={() => onChange(current - 1)}
                    disabled={current === 1}
                >
                    <span className={styles.chevron}>‹</span>
                    <span className={styles.btnText}>Previous</span>
                </button>
                
                <div className={styles.pageNumbers}>
                    {getPageNumbers().map((page, index) => (
                        <button
                            key={index}
                            className={`${styles.pageNumber} ${page === current ? styles.active : ''} ${page === '...' ? styles.ellipsis : ''}`}
                            onClick={() => page !== '...' && onChange(page)}
                            disabled={page === '...'}
                        >
                            {page}
                        </button>
                    ))}
                </div>
                
                <button 
                    className={`${styles.paginationBtn} ${current === totalPages ? styles.disabled : ''}`}
                    onClick={() => onChange(current + 1)}
                    disabled={current === totalPages}
                >
                    <span className={styles.btnText}>Next</span>
                    <span className={styles.chevron}>›</span>
                </button>
            </div>
        );
        }
    
        const allReportCols = [
            {
                title: 'File Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Quarter',
                dataIndex: 'quarter',
                key: 'quarter',
                render: (text, record) => (
                    <span>{text.toUpperCase()}</span>
                )
            },
            {
                title: 'Year',
                dataIndex: 'year',
                key: 'year',
            },
            {
                title: 'State',
                dataIndex: 'state',
                key: 'state',
                render: (text, record) => (
                    <span>{String(record.state).toUpperCase().replace(/{|}/g,"")}</span>
                )
            },
            {
                title: 'Generated Date',
                dataIndex: 'generateddate',
                key: 'generateddate',
                defaultSortOrder: 'descend',
                sorter: (a, b) => moment(a.generateddate).unix() - moment(b.generateddate).unix(),
                render: (text, record) => (
                    <span>{moment(record.generateddate).format("MM/DD/YYYY")}</span>
                )
            },
            {
                title: 'Actions',
                dataIndex: 'actions',
                key: 'actions',
                render: (text, record) => (
                    <div style={{display:"flex", gap:"10px"}}>
                            <img src="/images/callreport_view.svg" alt="view" onClick={()=>this.viewGeneratedReport(record)} className="mcr-pointer-effect" />
                            <img src="/images/callreport_export.svg" alt="export" onClick={()=>this.exportHistoryReport(record)} className="mcr-pointer-effect" />
                            <img src="/images/callreport_delete.svg" alt="delete" onClick={()=>this.deleteHistoryReport(record)} className="mcr-pointer-effect" />
                    </div>
                )
            },
        ]

        const handleChooseState = (checkedValues) => {
            this.setState({selectedStates: checkedValues});
        }

        const getSortedStatesOptions = () => {
            const { statesOptions, selectedStates } = this.state;
            
            // Separate selected and unselected options
            const selectedOptions = statesOptions.filter(option => 
                selectedStates.includes(option.value)
            );
            const unselectedOptions = statesOptions.filter(option => 
                !selectedStates.includes(option.value)
            );
            
            // Return selected options first, then unselected options
            return [...selectedOptions, ...unselectedOptions];
        }

        const handleStepsChange = (current) => {
            this.setState({currentstep: current});
        }

        const quarterOptions = [
            { label: 'Q1', value: 'q1' },
            { label: 'Q2', value: 'q2' },
            { label: 'Q3', value: 'q3' },
            { label: 'Q4', value: 'q4' }
        ]
 
       
        const steps = [
            {
              title: 'Select specifications',
              content: 
                <div style={{marginBottom: "24px"}}>
                    <Form 
                        labelAlign="left"
                        // onFinish={this.createReport}
                        onFinish={this.generateNewReportData}
                        initialValues={{
                            year: this.state.selectedYear,
                            quarter: this.state.selectedQuarter,
                            states: this.state.selectedStates
                          }}
                    >
                        <Row span={24} className="SpecificationInputs">
                            <Col span={4} className="pr-2">
                                <Form.Item
                                    label="Select quarter"
                                    name="quarter"
                                >  
                                    <Select className="selectFields" onChange={(value) => this.setState({selectedQuarter: value})} options={quarterOptions}/>
                                </Form.Item>
                            </Col>
                            <Col span={4} className="pr-2">
                                <Form.Item
                                    label="Select year"
                                    name="year"
                                >    
                                    <Select className="selectFields" onChange={(value) => this.setState({selectedYear: value})}>
                                        {this.getYears()}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    className="text-left"
                                    label="Select states"
                                    name="states"
                                    // rules={[{ required: true}]}
                                     >      
                                    <Select 
                                        mode="multiple" 
                                        className="multiselectFields" 
                                        onChange={handleChooseState} 
                                        options={getSortedStatesOptions()}
                                        optionRender={(option) => (
                                            <div>
                                                {option.data.label}
                                            </div>
                                        )}
                                        maxTagCount={4}
                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                        tagRender={(props) => {
                                            const { label, value, closable, onClose } = props;
                                            const onPreventMouseDown = (event) => {
                                                event.preventDefault();
                                                event.stopPropagation();
                                            };
                                            return (
                                                <span
                                                    onMouseDown={onPreventMouseDown}
                                                    style={{ marginRight: 3 }}
                                                    className="statesTags"
                                                >
                                                    {this.state.statesOptions.find(option => option.value === value)?.abbr}
                                                    {closable && (
                                                        <span style={{ marginLeft: 5 }} className="statesTagsClose" onClick={onClose}>
                                                            x
                                                        </span>
                                                    )}
                                                </span>
                                            );
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={2}></Col>
                            <Col span={6}>
                                <Form.Item
                                >   
                                    <Button className="generateButton" type="primary" htmlType="submit">Generate Report</Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
            },
            {
              title: 'Review, edit, and save data',
              content: 
                <CallReportPreview
                    selectedStates={this.state.selectedStates}
                    selectedQuarter={this.state.selectedQuarter}
                    selectedYear={this.state.selectedYear} 
                    updateCurrentStep={this.updateCurrentStep}
                    reportdata={this.state.callreportdata}
                    openingGeneratedReport={this.state.openingGeneratedReport}
                    Loans={this.state.Loans}
                    callreportdatatoSave={this.state.callreportdatatoSave}
                    setCallReportDatatoSave={(data) => this.setState({callreportdatatoSave: data})}
                    loanofficers={this.state.loanofficers}
                    setReportSaved={(data) => this.setState({reportSaved: data})}
                    setNewChange={(data) => this.setState({newChange: data})}
                />
            },
        ]

        const exportOptions = [
            {
                label: <div onClick={() => this.exportCallReport("excel")}>
                    Export as Excel
                </div>,
                key: "1",
            },
            // {
            //     label: <div onClick={() => this.exportCallReport("xml")}>
            //         Export as XML
            //     </div>,
            //     key: "2",
            // }
        ]

        return (
            <div>
                {this.state.loading ?
                    <>
                        <Skeleton active />
                        <Skeleton active />
                        <Skeleton active />
                    </>
                :
                    <div>
                        { this.state.currentstep === 0 && <div className="callReportStepOneWrap">
                            <div className="callReportMainHeader">Mortgage Call Reports</div>
                            <div style={{border:"1px solid #ECECEC",borderRadius:"8px", padding:"24px", marginBottom:"20px"}}>
                            <div className="text-left" style={{fontSize:"16px", fontWeight:"600",marginBottom:"15px"}}>Generate New Report</div>
                                <div style={{display:"flex", justifyContent:"space-between"}}>
                                    {this.state.currentstep === 1 && <div>
                                    <Button style={{width:"120px"}} type="primary" onClick={this.handelGoBack}>Go Back</Button>
                                    {/* <Dropdown menu={{items: exportOptions}}> */}
                                        <Button onClick={() => this.exportCallReport("excel")}>
                                            Export Report
                                        </Button>
                                    {/* </Dropdown> */}
                                    {!this.state.openingGeneratedReport &&<Button style={{marginLeft:"10px",width:"120px"}} type="primary" onClick={this.handleSaveReport} >Save Report</Button>}
                                    </div>}
                                </div>
                                <div>{steps[this.state.currentstep].content}</div>
                            </div>
                            {!this.state.currentstep && <div style={{border:"1px solid #ECECEC",borderRadius:"8px", padding:"24px"}} className="reportsTable">
                                <div className="text-left" style={{fontSize:"16px", fontWeight:"600",marginBottom:"10px"}}>Historical Reports</div>
                                <div className="descriptionText">View and download generated mortgage call reports below</div>
                                {/* make the table to display at most 5 rows in a page, add pagination */}
                                <Table 
                                    columns={allReportCols} 
                                    dataSource={this.getPaginatedData()} 
                                    bordered 
                                    className="historyReportTable"
                                    pagination={false}
                                />
                                {this.state.Records && this.state.Records.length > 3 && (
                                    <div className={styles.customPaginationWrapper}>
                                        <CustomPagination
                                            current={this.state.currentPage || 1}
                                            total={this.state.Records.length}
                                            pageSize={3}
                                            onChange={(page) => this.setState({ currentPage: page})}
                                        />
                                    </div>
                                )}
                            </div>}
                        </div>}
                        {this.state.currentstep === 1 && <div className="mt-3">
                            <div className="callReportStepWrapper">
                                <Button 
                                    className="backButton" 
                                    type="primary" 
                                    onClick={() => {
                                        if (this.state.openingGeneratedReport) {
                                            this.handelGoBack()
                                        } else if (!this.state.reportSaved) {
                                            this.setState({showConfirmBackModal: true})
                                        } else {
                                            this.handelGoBack()
                                        }
                                    }}
                                >
                                    Back
                                </Button>
                            </div>
                            <div className="callReportSubHeader">
                                <div className="subHeaderLeftBox">
                                    <div className="subHeaderTitle">Generate New Report</div>
                                    <div className="versionTip">{!this.state.openingGeneratedReport?this.state.selectedQuarter.toUpperCase():this.state.callreportdata.quarter.toUpperCase()}{this.state.openingGeneratedReport?"  "+this.state.callreportdata.year:("  " + this.state.selectedYear)}</div>
                                </div>
                                <div className="subHeaderRightBox">
                                    {/* {!this.state.openingGeneratedReport ? 
                                        (!this.state.reportSaved ? 
                                            <Button className="saveEditButton" type="primary" onClick={this.handleSaveReport} >Save edit</Button>
                                        : 
                                            (
                                                this.state.newChange ?
                                                <Button className="saveEditButton" type="primary" onClick={this.handleSaveReport} >Save edit</Button>
                                                :
                                                <div className="savedSuccessWrapper">
                                                    Changes saved
                                                    <img src="/images/check-circle.svg" alt="savedSuccess"/>
                                                </div>
                                            )
                                        )
                                    :
                                        ""
                                    } */}
                                    {/* {
                                        !this.state.openingGeneratedReport ?
                                            (!this.state.reportSaved ?
                                                ( this.state.newChange ?
                                                    <Button className="saveEditButton" type="primary" onClick={this.handleUpdateReport} >Save edit</Button>
                                                    :
                                                    <Button className="saveEditButton" type="primary" onClick={this.handleSaveReport} >Save edit</Button>
                                                )
                                            :
                                                    <div className="savedSuccessWrapper">
                                                        Changes saved
                                                        <img src="/images/check-circle.svg" alt="savedSuccess"/>
                                                    </div>
                                            )    
                                        :
                                            ""
                                    } */}
                                    {!this.state.openingGeneratedReport ?
                                        <Button className="saveEditButton" type="primary" onClick={this.handleSaveAndExit}>Save and exit</Button>
                                        :
                                        <></>
                                    }
                                    {/* <Dropdown menu={{items: exportOptions}}> */}
                                        <Button type="primary" className="exportAllButton" onClick={() => this.exportCallReport("excel")}>
                                            Export
                                        </Button>
                                    {/* </Dropdown> */}
                                </div>
                            </div>
                            <div>{steps[this.state.currentstep].content}</div>
                        </div>}
                        {this.renderConfirmBackModal()}
                    </div>
                }
            </div>
        );
    } 
}

export default CallReports;